"use strict";
// Core types and interfaces for the CoopAdventureEngine
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameStatus = exports.isPortraitVariant = exports.isIconVariant = exports.DEFAULT_PORTRAIT_VARIANT = exports.DEFAULT_ICON_VARIANT = exports.PORTRAIT_VARIANTS = exports.ICON_VARIANTS = exports.IdHelpers = void 0;
var ids_1 = require("./ids");
Object.defineProperty(exports, "IdHelpers", { enumerable: true, get: function () { return ids_1.IdHelpers; } });
var rich_text_1 = require("./rich-text");
Object.defineProperty(exports, "ICON_VARIANTS", { enumerable: true, get: function () { return rich_text_1.ICON_VARIANTS; } });
Object.defineProperty(exports, "PORTRAIT_VARIANTS", { enumerable: true, get: function () { return rich_text_1.PORTRAIT_VARIANTS; } });
Object.defineProperty(exports, "DEFAULT_ICON_VARIANT", { enumerable: true, get: function () { return rich_text_1.DEFAULT_ICON_VARIANT; } });
Object.defineProperty(exports, "DEFAULT_PORTRAIT_VARIANT", { enumerable: true, get: function () { return rich_text_1.DEFAULT_PORTRAIT_VARIANT; } });
Object.defineProperty(exports, "isIconVariant", { enumerable: true, get: function () { return rich_text_1.isIconVariant; } });
Object.defineProperty(exports, "isPortraitVariant", { enumerable: true, get: function () { return rich_text_1.isPortraitVariant; } });
var GameStatus;
(function (GameStatus) {
    GameStatus["ACTIVE"] = "active";
    GameStatus["COMPLETED"] = "completed";
    GameStatus["PAUSED"] = "paused";
    GameStatus["CLOSED"] = "closed";
})(GameStatus || (exports.GameStatus = GameStatus = {}));
//# sourceMappingURL=index.js.map